import { IconsEnum } from '@components/icons/types';

type TimelineContent = {
  icon: IconsEnum;
  title: string;
  text: string;
  professionals: string[];
};

export const timelineContent: TimelineContent[] = [
  {
    icon: IconsEnum['calendar-check'],
    title: 'Planejamento',
    text: 'O planejamento de conteúdos do Afya Whitebook começa com a identificação da necessidade de um novo tema ou da atualização de um conteúdo. Ela pode ser apontada por editores, conteudistas, equipe editorial, usuários ou por meio de análise de dados e passa por validação dos editores-chefes antes de entrar na esteira de produção.',
    professionals: ['Editores-chefes', 'Editores-assistentes', 'Editores-associados', 'Equipe editorial'],
  },
  {
    icon: IconsEnum.desktop,
    title: 'Produção',
    text: 'Na etapa de produção, um médico especialista é designado para elaborar ou atualizar o conteúdo, garantindo que ele seja baseado nas referências científicas mais atuais e adequadas ao contexto brasileiro. O conteúdo deve focar na aplicabilidade prática para apoiar os médicos em suas decisões clínicas.',
    professionals: ['Editores-associados', 'Editores-chefes', 'Conteudistas'],
  },
  {
    icon: IconsEnum.eye,
    title: 'Revisão Técnica',
    text: 'Todo conteúdo novo passa por uma revisão técnica feita por um segundo médico especialista, que assegura sua precisão, embasamento científico e alinhamento às diretrizes médicas. Além disso, há uma verificação de autenticidade das fontes citadas, garantindo que não haja plágio e que as referências sejam sempre as mais confiáveis.',
    professionals: ['Editores-chefes', 'Editores-assistentes', 'Editores-associados'],
  },
  {
    icon: IconsEnum['cards-three'],
    title: 'Padronização',
    text: 'Após a avaliação técnica, um revisor de texto faz a adequação ortográfica e de formatação do conteúdo, inclui imagens, vídeos e links complementares. Isso garante que todos os conteúdos sigam um padrão editorial coerente, favorecendo a clareza, a organização e a rápida consulta por médicos e estudantes usuários da plataforma.',
    professionals: ['Equipe editorial'],
  },
  {
    icon: IconsEnum.cursor,
    title: 'Publicação',
    text: 'Com todas as etapas anteriores concluídas, o conteúdo é liberado para visualização dentro do Afya Whitebook. Ele fica acessível aos usuários a qualquer momento e de qualquer lugar, oferecendo informações confiáveis, abrangentes e contextualizadas para a prática clínica.',
    professionals: ['Editores-chefes', 'Editores-assistentes', 'Editores-associados'],
  },
  {
    icon: IconsEnum['arrows-clockwise'],
    title: 'Atualização',
    text: 'O processo de atualização é contínuo e ocorre sempre que há novas evidências científicas, diretrizes ou mudanças em condutas médicas. A equipe editorial monitora constantemente estudos, protocolos e publicações científicas para garantir que o conteúdo do Afya Whitebook permaneça relevante e alinhado com as melhores práticas da medicina.',
    professionals: [
      'Editores-chefes',
      'Editores-assistentes',
      'Editores-associados',
      'Conteudistas',
      'Equipe editorial',
    ],
  },
];
